import * as api from '../api'
import { Dispatch } from '@reduxjs/toolkit';
import { endLoading, startLoading, setEnrollmentUsers } from '../reducers/enrollmentSlice';

export const actionCreateEnrollment = ({postData}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.createEnrollment({postData})
        dispatch({
            type: setEnrollmentUsers.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionFetchEnrollmentUsers = ({page}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.fetchEnrollmentUsers({page})
        dispatch({
            type: setEnrollmentUsers.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}